import React from 'react';
import { RainbowKitProvider, darkTheme, lightTheme } from '@rainbow-me/rainbowkit';
import { useTheme } from '../context/ThemeContext';
import { chain } from '../utils/wagmiConfig';

/**
 * Keeps the wallet modal aligned with app light/dark preference.
 */
export function ThemedRainbowKitProvider({ children }) {
    const { resolvedTheme } = useTheme();
    const theme =
        resolvedTheme === 'light'
            ? lightTheme({
                  accentColor: '#0f7669',
                  accentColorForeground: '#ffffff',
                  borderRadius: 'medium',
                  fontStack: 'system',
                  overlayBlur: 'small',
              })
            : darkTheme({
                  accentColor: '#14b8a6',
                  accentColorForeground: '#042f2e',
                  borderRadius: 'medium',
                  fontStack: 'system',
                  overlayBlur: 'small',
              });

    return (
        <RainbowKitProvider
            theme={theme}
            initialChain={chain}
            modalSize="compact"
            appInfo={{
                appName: 'CronPay',
                learnMoreUrl: 'https://rainbow.me',
            }}
        >
            {children}
        </RainbowKitProvider>
    );
}
